import { authenticatedGet } from "../../../api/authenticatedFetch";

const BASE_API = "/api/v1/financial-ownership";

// getOwnershipAccountability fetches the ownership & accountability payload for a period
// and audience lens. Returns the response object as-is.
export const getOwnershipAccountability = async (params = {}) => {
  return authenticatedGet(`${BASE_API}/accountability`, params);
};
